export const FETCH_TEASERBOXES = 'FETCH_TEASERBOXES'
export const FETCH_TEASERBOXES_PENDING = 'FETCH_TEASERBOXES_PENDING'
export const FETCH_TEASERBOXES_REJECTED = 'FETCH_TEASERBOXES_REJECTED'
export const FETCH_TEASERBOXES_FULFILLED = 'FETCH_TEASERBOXES_FULFILLED'
export const CLEAR_TEASERBOXES = 'CLEAR_TEASERBOXES'
export const BLOG_POST_CREATED = 'BLOG_POST_CREATED'
export const BLOG_POST_UPDATED = 'BLOG_POST_UPDATED'
